import { call, put, takeEvery } from "redux-saga/effects";

import {
  GRUPOTECNICO_LIST,
  GRUPOTECNICO_FULLLIST,
  GRUPOTECNICO_LISTA,
  GRUPOTECNICO_FILTER,
  GRUPOTECNICO_CREATE,
  GRUPOTECNICO_UPDATE,
  GRUPOTECNICO_READ,
  GRUPOTECNICO_DELETE,

} from "./actionTypes";

import {
  
  grupotecnicoListSuccess,
  grupotecnicoFullListSuccess,
  grupotecnicoCreateSuccess,
  grupotecnicoUpdateSuccess,
  grupotecnicoRequestFailed,
  grupotecnicoDeleteSuccess,
  grupotecnicoReadSuccess
 
} from "./actions";

import {
  getGrupoTecnicoList,
  getGrupoTecnicoFullList,
  getGrupoTecnicoLista,
  getGrupoTecnicoFilter,
  postGrupoTecnicoCreate,
  patchGrupoTecnicoUpdate,
  getGrupoTecnicoRead,
  deleteGrupoTecnico
} from "../../helpers/backend";



function*grupotecnicoListSaga() {
  console.log("Trayendo lista de grupotecnico...");
  try {
    const response = yield call(getGrupoTecnicoList);
    if (response.status === 200) {
      yield put(grupotecnicoListSuccess(response.data));
    } else {
      yield put(grupotecnicoRequestFailed(response.data));
    }
  } catch (error) {
    yield put(grupotecnicoRequestFailed(error.response.data));
  }
}
function*grupotecnicoFullListSaga() {
  console.log("Trayendo lista de FullList de grupotecnico ...");
  try {
    const response = yield call(getGrupoTecnicoFullList);
    if (response.status === 200) {
      yield put(grupotecnicoFullListSuccess(response.data));
    } else {
      yield put(grupotecnicoRequestFailed(response.data));
    }
  } catch (error) {
    yield put(grupotecnicoRequestFailed(error.response.data));
  }
}

function*grupotecnicoListaSaga() {
  console.log("Trayendo lista de grupotecnico...");
  try {
    const response = yield call(getGrupoTecnicoLista);
    if (response.status === 200) {
      yield put(grupotecnicoListSuccess(response.data));
    } else {
      yield put(grupotecnicoRequestFailed(response.data));
    }
  } catch (error) {
    yield put(grupotecnicoRequestFailed(error.response.data));
  }
}

function*grupotecnicoCreateSaga({ payload:grupotecnico }) {
  console.log("Creando nuevo grupotecnico...");
  try {
    const response = yield call(postGrupoTecnicoCreate,grupotecnico);
    if (response.status === 201) {
      yield put(grupotecnicoCreateSuccess(response.data));
    } else {
      yield put(grupotecnicoRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(grupotecnicoRequestFailed(error.response.data));
  }
}

function*grupotecnicoFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getGrupoTecnicoFilter, { changeUrl });
    if (response.status === 200) {
      yield put(grupotecnicoListSuccess(response.data));
    } else {
      yield put(grupotecnicoRequestFailed(response.data));
    }
  } catch (error) {
    yield put(grupotecnicoRequestFailed(error.response.data));
  }
}

function*grupotecnicoUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando datos de la herramienta...");
  
  try {
    const response = yield call(patchGrupoTecnicoUpdate,  id , data);
    if (response.status === 200) {
      yield put(grupotecnicoUpdateSuccess(response.data));
      
      
    } else {
      yield put(grupotecnicoRequestFailed(response.data));
      
    }
  } catch (error) {
    yield put(grupotecnicoRequestFailed(error.response.data));
    
  }
}

function*grupotecnicoDeleteSaga({ payload: { id } }) {
  console.log("Borrando datos del Grupo...");
  try {
    const response = yield call(deleteGrupoTecnico, id );
    if (response.status === 204) {
      yield put(grupotecnicoDeleteSuccess(response.data));
    } else {
      yield put(grupotecnicoRequestFailed(response.data));
    }
  } catch (error) {
    yield put(grupotecnicoRequestFailed(error.response.data));
  }
}


function* GrupotecnicoReadSaga({ payload: { id } }) {
  console.log("Probando...");
  try {
    const response = yield call(getGrupoTecnicoRead, id);

    if (response.status === 200) {
       yield put(grupotecnicoReadSuccess(response.data));
      } else {
        yield put(grupotecnicoRequestFailed(response.data));
      }
    } catch (error) {
      yield put(grupotecnicoRequestFailed(error.response.data));
    }

}

export default function*grupotecnicoSaga() {
  yield takeEvery(GRUPOTECNICO_LIST,grupotecnicoListSaga);
  yield takeEvery(GRUPOTECNICO_FULLLIST,grupotecnicoFullListSaga);
  yield takeEvery(GRUPOTECNICO_LISTA,grupotecnicoListaSaga);
  yield takeEvery(GRUPOTECNICO_FILTER,grupotecnicoFilterSaga);
  yield takeEvery(GRUPOTECNICO_CREATE,grupotecnicoCreateSaga);
  yield takeEvery(GRUPOTECNICO_UPDATE,grupotecnicoUpdateSaga);
  yield takeEvery(GRUPOTECNICO_READ,GrupotecnicoReadSaga);
  yield takeEvery(GRUPOTECNICO_DELETE,grupotecnicoDeleteSaga);
}
